/* eslint-disable no-unused-vars */
import $ from "jquery";

export default class Compensate {
    constructor() {
        $(document.body).on("updated_cart_totals", (evt) => {
            this.enableTrigger();
        });
        this.enableTrigger();
    }

    enableTrigger() {
        $("input[name='compensate']").change((evt) =>
            this.changeCompensation(evt)
        );
    }

    changeCompensation(evt) {
        let compensation = $("input[name='compensate']:checked")
            .attr("id")
            .split("-")[1];
        $.post(window.location.href + "?wc-ajax=compensate", {
            compensation: compensation,
        }).then(() => {
            $(document).trigger("wc_update_cart");
        });
    }
}
